'use strict'

import React from 'react'
import { View } from 'react-native'
import FSText from 'app/fs/components/FSText'
import FormLabelWithIcon from './FormLabelWithIcon'
import FSIcon from 'app/fs/components/FSIcon'
import { truncate } from 'app/fs/lib/utils/text'
import { colors } from 'app/fs/lib/styles'
import c from 'app/fs/views/NewPost/constants'

import { removeAttribute, editAttribute } from 'app/fs/actions/newPost'

export default class FormLabelLink extends React.Component {
  removeAttribute = () => {
    this.props.dispatch(removeAttribute('link_url'))
  }

  editAttribute = () => {
    this.props.dispatch(editAttribute('link_url'))
  }

  render() {
    var currentUser = dataStore.get('user', this.props.currentUserId)
    var colorForCurrentUser = colors.forUser(currentUser)

    return (
      <FormLabelWithIcon
        name="link"
        color={colorForCurrentUser}
        placeholder="Link"
        value={truncate(this.props.post.link_url, 40)}
        onPress={this.editAttribute}
        onRemove={this.removeAttribute}
      />
    )
  }
}
